import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import * as _ from 'lodash';
import { Lightbox } from 'ngx-lightbox';
import { NgxSpinnerService } from "ngx-spinner";
import { Toaster } from "ngx-toast-notifications";
import { LoggedInUser } from '../../../../shared/models/LoggedInUser';
import { AppSettingsService } from '../../../../shared/services/appsettings.service';
import { ContestEntriesModel } from '../../models/contestEntries.model';
import { ContestEntry } from '../../models/contestEntry.model';
import { VoteService } from '../../services/vote.service';


@Component({
  selector: 'contest-gallery',
  templateUrl: './contest-gallery.component.html',
  styleUrls: ['./contest-gallery.component.css']
})
export class ContestGalleryComponent implements OnInit {

  @Input('year') year: number;
  @Input('gradeCategoryId') gradeCategoryId: number;
  @Input() gradeCategoryName: any;
  pageEvent: PageEvent;
  selected: boolean = false;
  length = 0;
  pageSizeOptions: number[] = [20, 40, 60, 80, 100];
  pageSize = 0;
  choice1Count = 0;
  choice2Count = 0;
  choice3Count = 0;
  pictureGallery = [];
  contestVotes = [];
  choice1 = [];
  choice2 = [];
  choice3 = [];
  durationInSeconds = 5;
  loggedInUser: LoggedInUser[];
  @ViewChild('topPaginator', { static: true }) topPaginator: MatPaginator;
  @ViewChild('bottomPaginator', { static: true }) bottomPaginator: MatPaginator;
  imageIndex = 0;

  constructor(private _voteService: VoteService,
    private spinner: NgxSpinnerService,
    private toaster: Toaster,
    private _lightbox: Lightbox) {
    this.pageSize = AppSettingsService.settings.pageSize;
  }

  ngOnInit() {
    this.loadContestEntries({
      pageNumber: 0,
      pageSize: this.pageSize,
      startIndex: 0,
      endIndex: this.pageSize,
      year: this.year,
      gradeCategoryId: this.gradeCategoryId
    });
  }

  loadContestEntries(requestDto) {
    this.spinner.show();
    this._voteService.getContestEntries(requestDto)
      .subscribe(
        (response: ContestEntriesModel) => {
          this.pictureGallery = [...response.contestEntries];
          this.contestVotes = response.contestVotes;
          this.length = response.length;
          this.loadChoices();
        },
        error => {
          this.showNotification('Error retrieving contest entries.', false);
          this.spinner.hide();
        },
        () => this.spinner.hide()
      );
  }

  loadChoices() {
    var voteChoice1 = _.find(this.contestVotes, ['voteChoiceTypeId', 1]);
    if (!_.isNil(voteChoice1)) {
      _.remove(this.pictureGallery, function (n) {
        return n.contestEntryId == voteChoice1.contestEntryId;
      });
      this.choice1.push(voteChoice1);
      this.choice1Count++;
    }

    var voteChoice2 = _.find(this.contestVotes, ['voteChoiceTypeId', 2]);
    if (!_.isNil(voteChoice2)) {
      _.remove(this.pictureGallery, function (n) {
        return n.contestEntryId == voteChoice2.contestEntryId;
      });
      this.choice2.push(voteChoice2);
      this.choice2Count++;
    }

    var voteChoice3 = _.find(this.contestVotes, ['voteChoiceTypeId', 3]);
    if (!_.isNil(voteChoice3)) {
      _.remove(this.pictureGallery, function (n) {
        return n.contestEntryId == voteChoice3.contestEntryId;
      });
      this.choice3.push(voteChoice3);
      this.choice3Count++;
    }
  }

  dragImage(contestEntryId) {
    this.imageIndex = _.findIndex(this.pictureGallery, function (o) {
      return o.contestEntryId == contestEntryId;
    });
  }

  galleryDrop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      if (event.previousContainer.id === 'cdkListChoice1') {
        this.choice1Count--;
      }
      else if (event.previousContainer.id === 'cdkListChoice2') {
        this.choice2Count--;
      }
      else if (event.previousContainer.id === 'cdkListChoice3') {
        this.choice3Count--;
      }

      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
  }

  dropChoice1(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else if (this.choice1Count === 0) {
      this.choice1Count++;
      if (event.previousContainer.id === 'cdkListChoice1') {
        this.choice1 = [];
        this.choice1Count--;
      }
      else if (event.previousContainer.id === 'cdkListChoice2') {
        this.choice2 = [];
        this.choice2Count--;
      }
      else if (event.previousContainer.id === 'cdkListChoice3') {
        this.choice3 = [];
        this.choice3Count--;
      }

      transferArrayItem(event.previousContainer.data,
        event.container.data,
        this.imageIndex,
        event.currentIndex);
    }
  }

  dropChoice2(event: CdkDragDrop<any>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else if (this.choice2Count === 0) {
      this.choice2Count++;
      if (event.previousContainer.id === 'cdkListChoice1') {
        this.choice1 = [];
        this.choice1Count--;
      }
      else if (event.previousContainer.id === 'cdkListChoice2') {
        this.choice2 = [];
        this.choice2Count--;
      }
      else if (event.previousContainer.id === 'cdkListChoice3') {
        this.choice3 = [];
        this.choice3Count--;
      }

      transferArrayItem(event.previousContainer.data,
        event.container.data,
        this.imageIndex,
        event.currentIndex);
    }
  }

  dropChoice3(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else if (this.choice3Count === 0) {
      this.choice3Count++;
      if (event.previousContainer.id === 'cdkListChoice1') {
        this.choice1 = [];
        this.choice1Count--;
      }
      else if (event.previousContainer.id === 'cdkListChoice2') {
        this.choice2 = [];
        this.choice2Count--;
      }
      else if (event.previousContainer.id === 'cdkListChoice3') {
        this.choice3 = [];
        this.choice3Count--;
      }

      transferArrayItem(event.previousContainer.data,
        event.container.data,
        this.imageIndex,
        event.currentIndex);
    }
  }

  public setBottomPaginator(event: PageEvent) {
    this.topPaginator.pageSize = event.pageSize;
    this.topPaginator.pageIndex = event.pageIndex;
    this.topPaginator.page.emit(event);
  }

  OnPageChange(event: PageEvent) {
    let startIndex = event.pageIndex * event.pageSize;
    let endIndex = startIndex + event.pageSize;
    if (endIndex > this.length) {
      endIndex = this.length;
    }

    this.loadContestEntries({
      startIndex: startIndex,
      pageSize: event.pageSize,
      endIndex: endIndex,
      pageNumber: event.pageIndex,
      year: this.year,
      gradeCategoryId: this.gradeCategoryId
    });
  }

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    if (setPageSizeOptionsInput) {
      this.pageSizeOptions = setPageSizeOptionsInput.split(',').map(str => +str);
    }
  }

  public setFavorite(picture) {
    picture.isFavorite = !picture.isFavorite;
    if (picture.isFavorite) {
      let favoriteDto = {
        year: this.year,
        contestEntryId: picture.contestEntryId,
        active: true,
      };
      this._voteService.setFavorite(favoriteDto)
        .subscribe((data: ContestEntry) => {
          var contestEntry = _.find(this.pictureGallery, ['contestEntryId', picture.contestEntryId]);
          if (contestEntry) {
            contestEntry.contestFavoriteId = data.contestFavoriteId;
          }
        });
    }
    else {
      this._voteService.removeFavorite(picture.contestFavoriteId)
        .subscribe(data => {

        });
    }
    this.pictureGallery = _.sortBy(this.pictureGallery, o => o.contestFavoriteId)
  }

  public saveContestVote() {
    this.spinner.show();
    var contestVote = [];
    if (this.choice1.length > 0) {
      contestVote.push({ contestEntryId: this.choice1[0].contestEntryId, voteChoiceTypeId: 1 });
    }
    if (this.choice2.length > 0) {
      contestVote.push({ contestEntryId: this.choice2[0].contestEntryId, voteChoiceTypeId: 2 });
    }
    if (this.choice3.length > 0) {
      contestVote.push({ contestEntryId: this.choice3[0].contestEntryId, voteChoiceTypeId: 3 });
    }
    this._voteService.saveContestVote(this.year, this.gradeCategoryId, contestVote).subscribe(
      response => {
        this.showNotification('Vote saved successfully.');
      },
      error => {
        this.showNotification('Error saving contest vote.', false);
        this.spinner.hide();
      },
      () => this.spinner.hide()
    );
  }

  showNotification(message, success: boolean = true) {
    this.toaster.open({
      text: message,
      caption: success ? 'Success' : 'Error',
      type: success ? 'success' : 'danger'
    });
  }

  open(item): void {
    let items: Array<any> = [{ src: item.pictureName, thumb: item.pictureThumbName }];
    this._lightbox.open(items, 0);
  }

  close(): void {
    this._lightbox.close();
  }

}
